import { createApi } from "@reduxjs/toolkit/query/react";
import { encryptQueryString, transformRequest } from '../../../utils/API/requestMiddleware';
import { defautBaseQuery } from '../../../utils/API/fetchBaseQuery';
import { transformErrorResponse, transformSucessResponse } from "../../../utils/API/responseMiddleware";

const corporateCertificateApi = createApi({
    reducerPath: 'corporateCertificateApi',
    baseQuery: defautBaseQuery,
    endpoints: (builder) => ({
        getCertificateCorporateList: builder.mutation({
            query: (details) => ({
                url: '/CaseOfficerAndPeerReviewer/GetCertificateCorporateList',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllSGBPApplicationListByCorporateMemberIdForAdmin: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/CaseOfficerAndPeerReviewer/GetAllSGBPApplicationListByCorporateMemberIdForAdmin?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllSGBSApplicationListByCorporateMemberIdForAdmin: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/CaseOfficerAndPeerReviewer/GetAllSGBSApplicationListByCorporateMemberIdForAdmin?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getCompanyInformationByMemberId: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/CaseOfficerAndPeerReviewer/GetCompanyInformationByMemberId?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllSGBSCertificateListByCorporateMemberIdForAdmin: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/CaseOfficerAndPeerReviewer/GetAllSGBSCertificateListByCorporateMemberIdForAdmin?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllSGBPCertificateListByCorporateMemberIdForAdmin: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/CaseOfficerAndPeerReviewer/GetAllSGBPCertificateListByCorporateMemberIdForAdmin?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        downloadMUAPDF: builder.mutation({
            query: (details) => ({
                url: '/SelfEvaluation/DownloadMUAPDF',
                method: 'POST',
                body: transformRequest(details),
                responseHandler: (response) => response.blob(),
            }),
        }),
        getMUAPathsByApplicationId: builder.mutation({
            query: (details) => ({
                url: '/SelfEvaluation/GetMUAPathsByApplicationId',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        downloadIssuedCertificate: builder.mutation({
            query: (formData) => ({
                url: '/CaseOfficerAndPeerReviewer/DownloadIssuedCertificate',
                method: 'POST',
                body: transformRequest(formData),
                responseHandler: (response) => response.blob(),
            }),
        }),
    }),

})

export const {
    useGetCertificateCorporateListMutation,
    useLazyGetAllSGBPApplicationListByCorporateMemberIdForAdminQuery,
    useLazyGetAllSGBSApplicationListByCorporateMemberIdForAdminQuery,
    useLazyGetCompanyInformationByMemberIdQuery,
    useLazyGetAllSGBSCertificateListByCorporateMemberIdForAdminQuery,
    useLazyGetAllSGBPCertificateListByCorporateMemberIdForAdminQuery,
    useDownloadMUAPDFMutation,
    useGetMUAPathsByApplicationIdMutation,
    useDownloadIssuedCertificateMutation,
} = corporateCertificateApi;

export default corporateCertificateApi;